import React from "react";
import "./index.css";
import ButtonOutlined from "../../../../common/components/ButtonOutlined";
import img from "../../assets/pos-set.webp";

import { motion, useScroll } from "framer-motion";

const TopContainer = () => {
  const { scrollYProgress } = useScroll();
  return (
    <div className="top-container">
      <motion.div style={{ scaleX: scrollYProgress }} />
      <div className="top-container-body">
        <div className="top-container-logo"></div>
        <div className="top-container-body-content">
          <div className="maximize">Maximize Sales With Our Advanced</div>
          <div className="erp">ERP SOFTWARE SOLUTIONS</div>
          <div className="img-div">
            <img className="pos-img" src={img} alt="" loading="lazy" />
          </div>
          <div className="user">
            User-Friendly Point of Sale that allows you to give your customers
            live level of service they expect
          </div>
        </div>
        <div className="button-container">
          <a href="https://onboard.epinics.com/" target="_blank">
            <div className="free-trial">Free Trial</div>
          </a>
          <a
            href="https://web.whatsapp.com/send?phone=94741041212&text=Hello%2C%20I%20have%20an%20inquiry%20regarding%20your%20POS%20system.%20Could%20you%20please%20assist%20me%3F"
            target="_blank"
          >
            <div className="talk-to-sales">Talk To Sales</div>
          </a>
        </div>
        <div className="pos-set"></div>
      </div>
    </div>
  );
};

export default TopContainer;
